export const aciPhotoOfALandscape = {
    iconName: 'photo-of-a-landscape',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M20.478 3.197h-15.6a1.2 1.2 0 00-1.2 1.2v15.6a1.2 1.2 0 001.2 1.2h15.6a1.2 1.2 0 001.2-1.2v-15.6a1.2 1.2 0 00-1.2-1.2z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M7.43 15.93l2.59-3.455a1.121 1.121 0 011.693-.12l.769.768 2.47-3.293a1.123 1.123 0 011.796 0l1.999 2.664M8.27 9.193a1.403 1.403 0 100-2.807 1.403 1.403 0 000 2.807zM4.06 15.93h16.841',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
